/**
 * クライアント側の一時メッセージ表示（share/block-messages.blade.php と同じ見た目）。
 */

const CLIENT_MESSAGES_SELECTOR = '[data-jpenergy-client-messages]';
const BLOCK_MESSAGES_ROOT_SELECTOR = '[data-jpenergy-block-messages-root]';

const BLOCK_MESSAGE_VARIANTS = {
    danger: {
        itemClass: 'list-group-item-danger',
        iconClass: 'bi bi-x-circle',
    },
    warning: {
        itemClass: 'list-group-item-warning',
        iconClass: 'bi bi-exclamation-triangle',
    },
    info: {
        itemClass: 'list-group-item-info',
        iconClass: 'bi bi-info-circle',
    },
};

/**
 * @param {'danger'|'warning'|'info'} variant
 * @param {string} message
 */
function jpenergyShowClientBlockMessage(variant, message) {
    const root = document.querySelector(BLOCK_MESSAGES_ROOT_SELECTOR);
    if (!(root instanceof HTMLElement) || typeof message !== 'string' || message === '') {
        return;
    }

    const variantStyle = BLOCK_MESSAGE_VARIANTS[variant] ?? BLOCK_MESSAGE_VARIANTS.warning;
    let clientHost = root.querySelector(CLIENT_MESSAGES_SELECTOR);
    if (!(clientHost instanceof HTMLElement)) {
        clientHost = document.createElement('div');
        clientHost.setAttribute('data-jpenergy-client-messages', '');
        root.insertBefore(clientHost, root.firstChild);
    }

    clientHost.replaceChildren();

    const list = document.createElement('ul');
    list.className = 'list-group rounded-0';

    const listItem = document.createElement('li');
    listItem.className = `list-group-item ${variantStyle.itemClass}`;

    const icon = document.createElement('span');
    icon.className = variantStyle.iconClass;
    icon.append(document.createTextNode(` ${message}`));

    listItem.append(icon);
    list.append(listItem);
    clientHost.append(list);
}

function jpenergyClearClientBlockMessages() {
    const clientHost = document.querySelector(CLIENT_MESSAGES_SELECTOR);
    if (clientHost instanceof HTMLElement) {
        clientHost.replaceChildren();
    }
}

window.jpenergyShowClientBlockMessage = jpenergyShowClientBlockMessage;
window.jpenergyClearClientBlockMessages = jpenergyClearClientBlockMessages;

export { jpenergyClearClientBlockMessages, jpenergyShowClientBlockMessage };
